import React from "react";
import { useSelector } from "react-redux";
import { map } from "lodash";

import { AutoComplete } from "components/inputs";
import { getSpecialtyConfigurableTriageCategorySettings } from "app/auth/store/reducers/system-configuration";

const TriageCategorySelector = ({ field, form, ...other }) => {
  const triageCategorySettings = useSelector(getSpecialtyConfigurableTriageCategorySettings);

  const options = map(triageCategorySettings, x => ({ value: x.triageCategory, label: x.label }));

  const handleChange = (newValue, fieldName, setFieldValue) => {
    const selectedObjects = map(newValue, option => ({
      value: option.value,
      label: option.label,
    }));
    setFieldValue(fieldName, selectedObjects);
  };

  return (
    <AutoComplete
      label={other.label}
      options={options}
      filterSelectedOptions
      multiple
      getOptionSelected={(option, val) => option.value === val?.value}
      field={{ name: field.name, value: field.value }}
      form={form}
      handleOnChange={handleChange}
      {...other}
    />
  );
};

export default TriageCategorySelector;
